import { Collapse } from "antd";
import styles from "./faq.module.scss";

const FAQ = () => {
  return (
    <div className={styles.faq_section}>
      <div className={styles.faq}>
        <Collapse
          className={styles.collapse}
          bordered={false}
          expandIconPosition="end"
        >
          <Collapse.Panel
            header="What crypto wallet can I use on MonbaseNFT?"
            key="faq1"
          >
            You can use Metamask, Trust Wallet or any wallets that support BNB
            Chain.
          </Collapse.Panel>

          <Collapse.Panel
            header="Can I trade NFTs for other cryptocurrencies or assets?"
            key="faq2"
          >
            Monbase NFT supports users to trade NFTs for MBC tokens
          </Collapse.Panel>

          <Collapse.Panel
            header="Which blockchains is Monbase NFT compatible with?"
            key="faq3"
          >
            Monbase NFT is a NFT marketplace and launchpad supporting BNB Chain
            In the future, we will integrate more EVM blockchains (Ethereum,
            Polygon) and non-EVM blockchains (Solana)
          </Collapse.Panel>
        </Collapse>
      </div>
      <img src={require("../../../../assets/images/1x/faq-img.jpg")} alt="" />
    </div>
  );
};

export default FAQ;
